import React from 'react';
import GestionPersonal from '../roles/GestionPersonal';
import { useNavigate } from 'react-router-dom';
import './Promotores.css';

// La ruta existente conserva un único contrato de mantenimiento en /usuarios.
export default function Promotores() {
  const navigate = useNavigate();
  return <div className="promos-page">
    <header className="promos-top">
      <div><h1>Promotores (RRPP / Imagen)</h1><p className="promos-sub">Administra roles y accesos de usuarios RRPP e Imagen ya registrados.</p></div>
      <button className="promos-btn promos-btn--ghost" type="button" onClick={() => navigate(-1)}>Volver</button>
    </header>
    <GestionPersonal soloRelacionadores />
  </div>;
}
